import { render, staticRenderFns } from "./SectionSubtitle.vue?vue&type=template&id=50e381ad"
import script from "./SectionSubtitle.vue?vue&type=script&lang=js"
export * from "./SectionSubtitle.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports